import React from "react";

const History = () => {
  return (
    <div className="mt-16">
      <div className="bg-[#061E42] p-3">
        <p className="text-35 font-extraBold">Description</p>
        <p className="text-18 text-white font-normal">
          There are many variations of passages of Lorem Ipsum available, but
          the majority have suffered alteration in some form, by injected
          humour, or randomised words which don't look even slightly believable.
          If you are going to use a passage of Lorem Ipsum, you need to be sure
          there isn't anything embarrassing hidden in the middle of text. All
          the Lorem Ipsum generators on the Internet tend to repeat predefined
          chunks as necessary, making this the first true generator on the
          Internet.
        </p>
      </div>

      <div className="my-14">
        <div className="overflow-x-auto">
          <div className="bg-[#061E42] w-full p-3">
            <p className="text-24 font-extraBold uppercase">History</p>
          </div>
          <table className="table-auto w-[475px] md:w-full">
            <thead className=" h-16 font-semibold capitalize text-white bg-[#0C2B58] rounded-5">
              <tr className="">
                <th className="py-2 px-8 whitespace-nowrap ">
                  <div className="font-extraBold text-center text-white text-18 m-1 uppercase">
                    From
                  </div>
                </th>
                <th className="py-2 px-8 whitespace-nowrap ">
                  <div className="font-extraBold text-center text-white text-18 uppercase">
                    To
                  </div>
                </th>
                <th className="py-2 px-8  whitespace-nowrap">
                  <div className="font-extraBold text-center text-white text-18 uppercase">
                    TYPE
                  </div>
                </th>
                <th className="py-2 px-8  whitespace-nowrap">
                  <div className="font-extraBold text-center text-white text-18 uppercase">
                    WHen
                  </div>
                </th>
                <th className="py-2 px-8  whitespace-nowrap">
                  <div className="font-extraBold text-center text-white text-18 uppercase">
                    Price
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm  ">
              <tr className=" bg-[#061E42] h-10">
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center">
                    <div className="">
                      <img
                        className="w-24 h-16"
                        src="images/logoPolyVerse.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20 flex justify-center">
                    <img
                      className="w-12 h-12 rounded-full"
                      src="images/tol.png"
                      alt="profile"
                    />
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>Mint</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>10/10/23</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center ml-9">
                    <div className="font-medium text-20 text-center text-white w-20">
                      <p className="uppercase">150,00</p>
                    </div>
                    <div className="w-10 h-10 flex items-center ml-3 sm:mr-3">
                      <img
                        className="rounded-full w-6 h-6 gap-4"
                        src="/images/singleCoin.png"
                        alt="coin"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr className=" bg-[#061E42] h-10">
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center">
                    <div className="">
                      <img
                        className="w-24 h-16"
                        src="images/logoPolyVerse.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20 flex justify-center">
                    <img
                      className="w-12 h-12 rounded-full"
                      src="images/tol.png"
                      alt="profile"
                    />
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>Mint</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>10/10/23</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center ml-9">
                    <div className="font-medium text-20 text-center text-white w-20">
                      <p className="uppercase">150,00</p>
                    </div>
                    <div className="w-10 h-10 flex items-center ml-3 sm:mr-3">
                      <img
                        className="rounded-full w-6 h-6 gap-4"
                        src="/images/singleCoin.png"
                        alt="coin"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr className=" bg-[#061E42] h-10">
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center">
                    <div className="">
                      <img
                        className="w-24 h-16"
                        src="images/logoPolyVerse.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20 flex justify-center">
                    <img
                      className="w-12 h-12 rounded-full"
                      src="images/tol.png"
                      alt="profile"
                    />
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>Mint</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>10/10/23</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center ml-9">
                    <div className="font-medium text-20 text-center text-white w-20">
                      <p className="uppercase">150,00</p>
                    </div>
                    <div className="w-10 h-10 flex items-center ml-3 sm:mr-3">
                      <img
                        className="rounded-full w-6 h-6 gap-4"
                        src="/images/singleCoin.png"
                        alt="coin"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr className=" bg-[#061E42] h-10">
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center">
                    <div className="">
                      <img
                        className="w-24 h-16"
                        src="images/logoPolyVerse.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20 flex justify-center">
                    <img
                      className="w-12 h-12 rounded-full"
                      src="images/tol.png"
                      alt="profile"
                    />
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>Mint</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="text-center text-white text-20">
                    <p>10/10/23</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap border-b-2 border-[#20477E]">
                  <div className="flex items-center justify-center ml-9">
                    <div className="font-medium text-20 text-center text-white w-20">
                      <p className="uppercase">150,00</p>
                    </div>
                    <div className="w-10 h-10 flex items-center ml-3 sm:mr-3">
                      <img
                        className="rounded-full w-6 h-6 gap-4"
                        src="/images/singleCoin.png"
                        alt="coin"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr className=" bg-[#061E42] h-10">
                <td className="p-2 whitespace-nowrap">
                  <div className="flex items-center justify-center">
                    <div className="">
                      <img
                        className="w-24 h-16"
                        src="images/logoPolyVerse.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap">
                  <div className="text-center text-white text-20 flex justify-center">
                    <img
                      className="w-12 h-12 rounded-full"
                      src="images/tol.png"
                      alt="profile"
                    />
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap ">
                  <div className="text-center text-white text-20">
                    <p>Mint</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap ">
                  <div className="text-center text-white text-20">
                    <p>10/10/23</p>
                  </div>
                </td>
                <td className="p-2 whitespace-nowrap ">
                  <div className="flex items-center justify-center ml-9">
                    <div className="font-medium text-20 text-center text-white w-20">
                      <p className="uppercase">150,00</p>
                    </div>
                    <div className="w-10 h-10 flex items-center ml-3 sm:mr-3">
                      <img
                        className="rounded-full w-6 h-6 gap-4"
                        src="/images/singleCoin.png"
                        alt="coin"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default History;
